// extracted by mini-css-extract-plugin
module.exports = {"layout-nav-width":"176px","layout-titlebar-height":"72px","layout-scrollarea-margin":"88px"};